<template>
	<div>
		<div class="bio-pane active">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<label>日期 <el-date-picker size="small" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" v-model="filter.date" @change="handleFilter(3,1, $event)"></el-date-picker></label>
					<div style="display: inline-block;">
						数据源
						<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.dataType" @change="handleFilter(3,2, $event)">
							<el-option v-for="item in sourceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</div>
					<div class="flr">
						<el-button type="primary" size="mini" round @click="onShowForm('add')">添加体重</el-button>
						<el-link class="mode noline" :class="{active: viewMode == 1}" @click="handleMode(1)"><i class="icon-table"></i></el-link>
						<el-link class="mode noline" :class="{active: viewMode == 2}" @click="handleMode(2)"><i class="icon-chart2"></i></el-link>
					</div>
				</el-form>
			</div>
			
			<div class="pane-mode table-wrap" :class="{active: viewMode == 1}">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading">
					<el-table-column prop="measuringTime" label="测量时间" show-overflow-tooltip min-width="120"></el-table-column>
					<el-table-column prop="weight" label="体重(kg)" min-width="120"></el-table-column>
					<el-table-column prop="height" label="身高(cm)" min-width="120"></el-table-column>
					<el-table-column prop="bmi" label="BMI" min-width="120">
						<template slot-scope="scope"><span class="lv" :class="['lv'+ scope.row.bmiLevel]">{{ scope.row.bmi ? scope.row.bmi : '未测量'}}</span>{{scope.row.bmiReferRange ? '('+scope.row.bmiReferRange+')' : ''}}</template>
					</el-table-column>
					<el-table-column prop="dataType" label="数据源" width="100">
						<!-- <template slot-scope="scope">
							<span v-if="scope.row.dataType == 0">入院</span>
							<span v-else-if="scope.row.dataType == 1">出院</span>
							<span v-else-if="scope.row.dataType == 2">门诊</span>
							<span v-else-if="scope.row.dataType == 3">随访</span>
						</template> -->
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="100" >
						<template slot-scope="scope">
							<div class="tab-action" v-if="scope.row.dataType=='后台录入'">
								<el-tooltip content="修改" slot="reference" placement="top" :enterable="false">
										<i @click="onShowForm(scope.row)" class="el-icon-edit" />
								</el-tooltip>
								<el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delItem(scope.row)">
									<el-tooltip content="删除" slot="reference" placement="top" :enterable="false">
											<i class="el-icon-delete"></i>
									</el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>				
			</div>
			<div class="pane-mode chart" :class="{active: viewMode == 2}">
				<chart :options="chartOpts1" style="margin-bottom: 30px;"></chart>
				<chart :options="chartOpts2"></chart>
			</div>
		</div>


		<el-dialog :title.sync="dialogTit" width="550px" center :visible.sync="isFormActive" v-if="isFormActive">
			<el-form ref="form" label-width="120px" :rules="rules" :model="form">
				<el-form-item label="测量时间：" prop="measuringTime">
					<el-date-picker v-model="form.measuringTime" value-format="yyyy-MM-dd HH:mm:ss" :clearable="false" type="datetime"></el-date-picker>
				</el-form-item>
				<el-form-item label="体重：" prop="weight">
					<el-input clearable v-model="form.weight" ></el-input> kg
				</el-form-item>
				<el-form-item label="身高：" prop="height">
					<el-input clearable v-model="form.height" ></el-input> cm
				</el-form-item>
				<el-form-item label="BMI：">
					<span v-if="form.weight > 0 && form.height > 0">{{ getBMI() }}</span>
					<span v-else>输入体重、身高后自动计算</span>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="onSave">保 存</el-button>
			</div>
		</el-dialog>	


	</div>	
</template>

<script>
import mixin from '@/views/mixin';
import {Chart} from 'highcharts-vue';
import api from '@/service/api.js';
import dayjs from 'dayjs';
import { throttle } from "throttle-debounce";

export default {
	components: {Chart},
  mixins: [mixin],
	props: {
		patientId: { required: true }
	},
	data(){
		let checkResult = (rule, value, callback) => {
			if (!Number(value)) return callback(new Error('请输入数字值'))
			let reg = /((^[1-9]\d*)|^0)(\.\d{0,9}){0,1}$/;
			if (!reg.test(value)) return callback(new Error('请输入正确数值'));
			callback();
		}
		return {
			noSidebar: true,
			sourceList:[],
			dialogTit:'',
			filter:{
				patientId: 0,
				dataType: '',
				type:'',
				measuringTimeStart: '',
				measuringTimeEnd: '',
				date: [],
				pageNumber: 1,
				pageSize: 30
			},
			viewMode: 1,
			isFormActive: false,
			rules: {
				height: [{required: true, message: '请输入',},
					{ validator: checkResult, trigger: 'blur' }],
				weight: [{required: true, message: '请输入',},
					{ validator: checkResult, trigger: 'blur' }],
			},			
			form: {
				patientId: 0,
				measuringTime: undefined,
				height: undefined,
				weight: undefined,
				bmi: undefined,
				dataType: 3,
				dataId: 0,
			},
			list: {pageSize: 30, pageCount: 50, total: 300,data: []},
			chartOpts1: {
				credits: { enabled: false },
				title: { text: 'BMI趋势图', verticalAlign: 'top' },
				subtitle: {
					useHTML: true,
					style: {color: '#55759b'},
					text: undefined,
				},
				xAxis: {
					categories: [],
					crosshair: true
				},
				yAxis: {
					title: {
						useHTML: true,
						text: ''
					}
				},
				plotOptions: {
					line: {
						dataLabels: { enabled: true },
						enableMouseTracking: true
					}
				},
				series: [{
					name: 'BMI',
					showInLegend: false,
					data: []
				}]
			},
			chartOpts2: {
				credits: { enabled: false },
				title: { text: '体重(kg)趋势图', verticalAlign: 'top' },
				subtitle: {
					useHTML: true,
					style: {color: '#55759b'},
					text: undefined,
				},
				xAxis: {
					categories: [],
					crosshair: true
				},
				yAxis: {
					title: {
						useHTML: true,
						text: ''
					}
				},
				plotOptions: {
					line: {
						dataLabels: { enabled: true },
						enableMouseTracking: true
					}
				},
				series: [{
					name: '体重',
					showInLegend: false,
					data: []
				}]
			}		
		}
	},
	created() {
		// let query = this.$route.query;
		this.filter.patientId = this.patientId;
		this.loadList();
		
		// 获取 来源下拉
		api.getPatientBioSourceType({}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.sourceList = res.data;
			}
		});
	},
	methods: {
		async loadList(){
			// 获取 血压数据
			const filter = JSON.parse(JSON.stringify(this.filter));
			filter.date = undefined;
			this.form.weight = undefined;
			this.form.height = undefined;
			this.form.bmi = undefined;
			let res = await api.getPatientLabBasic(filter);
			if (res.code == 1000 && res.data) {
				if (res.data) {
					res.data.forEach((item)=>{
						item.bmiLevel = this.getLevel(1,item.bmiExceptionTip);
					})
					this.list.total = +res.total;
					this.list.current = this.filter.pageNumber;
					this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);					
					this.list.data = res.data;
					//身高取最新的一条数据的身高
					if(res.data.length>0){
						this.form.height = res.data[0].height
					}
					let labels = [];
					let bmis = [];
					let weights = [];
					res.data?.forEach(item => {
						labels.push(item.measuringTime ? dayjs(item.measuringTime).format('YYYY-MM-DD') : '无效日期');
						bmis.push(+item.bmi);
						weights.push(+item.weight);
					});
					this.chartOpts1.xAxis.categories = labels.reverse();
					this.chartOpts1.series[0].data = bmis.reverse();

					this.chartOpts2.xAxis.categories = labels.reverse();
					this.chartOpts2.series[0].data = weights.reverse();

					// 图表数据
					// this.chartOpts.xAxis.categories = labels;
					// this.chartOpts.series = [
					// 	{
					// 		name: '收缩压',
					// 		color: 'blue',
					// 		data: sbps
					// 	},
					// 	{
					// 		name: '舒张压',
					// 		color: 'red',
					// 		data: dbps,
					// 	}
					// ];
					if (labels.length > 0) {
						this.chartOpts1.subtitle = { text: `<div>BMI(峰值:${Math.max(...bmis)} 谷值:${Math.min(...bmis)} 均值: ${this.MathAvg(bmis)})</div>` } 
						this.chartOpts2.subtitle = { text: `<div>BMI(峰值:${Math.max(...weights)}kg 谷值:${Math.min(...weights)}kg 均值: ${this.MathAvg(weights)}kg)</div>` } 
					} else {
						this.chartOpts1.subtitle = { text: undefined };
						this.chartOpts2.subtitle = { text: undefined };
					}
					
				}
			}

		},
		// 求平均值
		MathAvg(arr) {
			return (arr.reduce((pre, cur) => pre + cur) / arr.length).toFixed(1);
		},
		getBMI(){
			return (this.form.weight / Math.pow(this.form.height / 100, 2)).toFixed(1);
		},
		handleMode(key) {
			this.viewMode = key;
		},
		handleFilter(key, val) {
			if(val == 1){
				// 时间筛选
				if (this.filter.date) {
					this.filter.startTime = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
					this.filter.endTime = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
				} else {
					this.filter.startTime = '';
					this.filter.endTime = '';						
				}
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},
		onShowForm(item) {
			this.isFormActive = true;
			if(item=='add'){
				this.$refs['form'].resetFields();
				this.dialogTit='添加体重';
				this.form.measuringTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
				//身高取最新的一条数据的身高
				if(this.list.data.length>0){
					this.form.height = this.list.data[0].height;
				}
				this.form.weight=item.undefined;
				this.form.bmi=undefined;
			} else {
				this.dialogTit='修改体重';
				this.form.measuringTime=item.measuringTime;
				this.form.weight=item.weight;
				this.form.height=item.height;
				this.form.bmi=item.bmi;
				this.form.id=item.id;
			}

		},
		onSave:throttle(3000,true,function(){
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					this.form.patientId = this.patientId;
					this.form.bmi = this.getBMI();
					if(this.dialogTit=='添加体重'){
						let res = await api.addPatientLabBasic(this.form);
						if (res.code != 1000) {
							this.$message.console.error(res.msg);
							return;
						}
						this.$message.success('添加成功');
					} else {
						let res = await api.updatePatientLabBasic(this.form);
						if (res.code != 1000) {
							this.$message.console.error(res.msg);
							return;
						}
						this.$message.success('修改成功');
					}
					this.isFormActive = false;
					this.loadList();
				}
			});
		}) ,
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		getLevel(v,key){
			if(v != 0){
				switch(key){
					case '高': return 4;
					case '低': return 1;
					default : return 0;
				}
			}
		},
		async delItem(item){
			let res =await api.delPatientLabBasic([String(item.id)]);
			if(res.code==1000){
				this.$message.success('删除成功');
				this.loadList();
			}
		}
	}
}	
</script>
<style lang="less" scoped>
.tab-action{
	display: flex;
	justify-content: center;
}
</style>